import {useCallback} from 'react';

export interface JobFilters {
    [key: string]: string[];
}

interface FilterFnsRes {
    toggleCheckboxFilter: (e: any, filterName: string, value: string) => void;
    setLocationFilter: (e: any, filterName: string, value: string) => void;
    removeFilter: (e: any, filterName: string, value: string) => void;
}

export const useFilterFns = (
    jobsFilters: JobFilters,
    setJobsFilters: (f: JobFilters) => void,
    jobResultsPage: number,
    setJobResultsPage: (n: number) => void
): FilterFnsRes => {
    const toggleCheckboxFilter = useCallback(
        (e, filterType: string, value: string) => {
            const updatedJobFilters = Object.assign({}, jobsFilters);

            //get existing filter values list
            const filterArray = updatedJobFilters[filterType] || [];
            const exists = Object.prototype.hasOwnProperty.call(jobsFilters, filterType);
            const index = filterArray.indexOf(value);

            if (Array.isArray(filterArray)) {
                //if checked, append filter to list
                index === -1 && filterArray.push(value);

                //if unchecked, remove filter from list
                if (exists) {
                    if (index > -1) {
                        filterArray.splice(index, 1);
                    }
                }

                //Update filters object with selected filters or delete filter key from object if none select
                filterArray.length > 0
                    ? (updatedJobFilters[filterType] = filterArray)
                    : delete updatedJobFilters[filterType];
            }

            setJobResultsPage(1);
            setJobsFilters(updatedJobFilters);
        },
        [jobsFilters, setJobsFilters, jobResultsPage]
    );

    const setLocationFilter = useCallback(
        (e, filterType, value) => {
            const updatedJobFilters = Object.assign({}, jobsFilters);

            //update value
            if (value) {
                updatedJobFilters[filterType] = [value];
            } else {
                delete updatedJobFilters[filterType];
            }

            if (filterType === 'country') {
                //on country change, clear state and city selections
                delete updatedJobFilters['state'];
                delete updatedJobFilters['city'];
            } else if (filterType === 'state') {
                //on state change, clear city selection
                delete updatedJobFilters['city'];
            }

            setJobResultsPage(1);

            setJobsFilters(updatedJobFilters);
        },
        [jobsFilters, setJobsFilters, jobResultsPage]
    );

    const removeFilter = useCallback(
        (e, filterType, value) => {
            const updatedJobFilters = Object.assign({}, jobsFilters);

            //get existing filter values list
            const filterArray = updatedJobFilters[filterType] || [];
            if (Array.isArray(filterArray)) {
                const index = filterArray.indexOf(value);
                if (index > -1) {
                    filterArray.splice(index, 1);
                }

                //Update filters object with selected filters or delete filter key from object if none select
                filterArray.length > 0
                    ? (updatedJobFilters[filterType] = filterArray)
                    : delete updatedJobFilters[filterType];
            }

            setJobResultsPage(1);
            setJobsFilters(updatedJobFilters);
        },
        [jobsFilters, setJobsFilters, jobResultsPage]
    );

    return {
        toggleCheckboxFilter,
        setLocationFilter,
        removeFilter
    };
};
